import React, { Component } from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Fetcher } from '../../../Helpers/fetcher.js';
import { Notify } from '../../../Helpers/notification.js';

class SheetView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sheet: null,
			loading: true
		}
	}

	componentDidMount() {
		if (this.props.app.role !== 'ROLE_SADMIN' && this.props.app.role !== 'ROLE_SUB_SADMIN') {
			this.props.history.replace('/');
			return;
		}
		this.getSheet();
	}

	getSheet = () => {
		const apiPath = this.props.app.apiPath;
		const id = this.props.match.params.id;
		this.setState({ loading: true });
		Fetcher.get(apiPath + '/api/obd/sheet/content/' + id)
			.then(res => {
				this.setState({ sheet: res });
			})
			.catch(err => {
				console.log('Error in fetching Sheet Content', err);
				Notify.notify('Error in fetching Sheet Content');
			})
			.finally(() => this.setState({ loading: false }));
	}

	render() {
		const { sheet, loading } = this.state;
		const urlPrefix = this.props.app.urlPrefix || '';
		const pages = sheet
			? [sheet.content1, sheet.content2, sheet.content3, sheet.content4, sheet.content5].filter(c => c && c.trim() !== '')
			: [];

		return (
			<Card>
				<Card.Header>
					{sheet ? sheet.sheetName : 'Sheet'}
					<Link to={`${urlPrefix}/superadmin-api-docs/sheet-content`} className="float-right btn btn-secondary btn-sm">Back</Link>
				</Card.Header>
				<Card.Body>
					{loading ? (
						<div className="text-center"><Spinner animation="border" /></div>
					) : !sheet ? (
						<div>Sheet not found.</div>
					) : pages.length === 0 ? (
						<div>No content available yet.</div>
					) : (
						pages.map((content, idx) => (
							<div key={idx} className="sheet-view-page mb-4" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
								<div dangerouslySetInnerHTML={{ __html: content }} />
								{idx < pages.length - 1 && <hr />}
							</div>
						))
					)}
				</Card.Body>
			</Card>
		);
	}
}

export default SheetView;
